"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRecord_1 = __importDefault(require("./valueIsRecord"));
const assertionSymbol = Symbol('assertionSymbol');
const valueIsShapeAssertion = (validationMap) => ((value) => {
    if (!(0, valueIsRecord_1.default)(value)) {
        return false;
    }
    const notMatched = Object.entries(validationMap).find(([propName, propValidator]) => {
        const propValue = value[propName];
        const assertion = propValidator;
        return !assertion(propValue);
    });
    return !notMatched;
});
exports.default = valueIsShapeAssertion;
